// removed by extract-text-webpack-plugin
module.exports = {"hidden":"sq6_G","visuallyhidden":"_1FZ5l","hide-text":"_1I2zl","center":"_1eq3R","noprint":"_36QT9","root":"_2WE5R","aspectRatio":"_3_vCy","iframeContent":"_88scx","twitter-tweet":"X1I0p","facebook-post":"_1FuCq","instagram-image":"_1TjP1","spotify-audio":"_1NlT1","soundcloud-audio":"BlL5g"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-embed-content/styles/default.scss
 ** module id = 995
 ** module chunks = 2
 **/